import type { ReactNode } from 'react';
import { cx } from '../lib/cx';

export type PillTone = 'neutral' | 'accent' | 'success' | 'warn' | 'danger' | 'violet';

const TONES: Readonly<Record<PillTone, string>> = {
  neutral: 'border-line-strong bg-surface-2 text-muted',
  accent: 'border-accent-border bg-accent-tint text-accent-strong',
  success: 'border-transparent bg-success-tint text-success',
  warn: 'border-warn-border bg-warn-tint text-warn',
  danger: 'border-danger-border bg-danger-tint text-danger',
  violet: 'border-violet-border bg-violet-tint text-violet-strong',
};

export interface PillProps {
  readonly tone?: PillTone;
  readonly children: ReactNode;
  readonly className?: string;
  /** Screen-reader context, e.g. "Status" — the visual label is the colour plus the text. */
  readonly title?: string;
}

/** A hairline status chip. Radius stays at --radius-xs so it reads as a tag, not a badge. */
export function Pill({ tone = 'neutral', children, className, title }: PillProps) {
  return (
    <span
      title={title}
      className={cx(
        'inline-flex items-center gap-1 rounded-xs border px-1.5 py-0.5 fs-11 font-medium leading-4',
        TONES[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
